import React, { useState } from 'react'

export interface IPageContext {
  pageContext?: BASE.Helpers.IPageContext
  setPageContext: React.Dispatch<
    React.SetStateAction<BASE.Helpers.IPageContext | undefined>
  >
}

export const PageContext = React.createContext<IPageContext>({
  pageContext: undefined,
  setPageContext: () => undefined,
})

export type PageContextProviderProps = {
  children: React.ReactNode
  pageContext: BASE.Helpers.IPageContext
}

export default function PageContextProvider({
  children,
  pageContext,
}: PageContextProviderProps): React.ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [_, setPageContext] = useState<BASE.Helpers.IPageContext>()

  return (
    <PageContext.Provider value={{ pageContext, setPageContext }}>
      {children}
    </PageContext.Provider>
  )
}
